import { Pipe, PipeTransform } from '@angular/core';
import { Tag } from '@isophi/pap-api';
import { msmtCompetenceNumber } from '../components/portfolio-plan-competence/competence-groups';

/** Number of an MŠMT framework competence ('1.1'-'6.3'); null for areas and old framework tags. */
@Pipe({
  name: 'competenceNumber',
  standalone: false,
})
export class CompetenceNumberPipe implements PipeTransform {
  transform(tag: Pick<Tag, 'name'> | null | undefined): string | null {
    return tag ? msmtCompetenceNumber(tag) : null;
  }
}
